import { styled } from '../../../theme/stitches.config';

export const SMPKnockoutSmallFinal = styled.withConfig({ componentId: 'CommonWidget', displayName: 'KnockoutSmallFinal' })('div', {
  border: '1px solid $knockoutHeaderBorderColor',
  py: '$2',
  px: '$2',
  borderRadius: '$2',
  alignItems: 'center',
  bc: '$knockoutHeaderBgColor',
  marginBottom: '$2',
});
